/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { qreq } from "../../shared/qrequest";
import AppActions from "../AppActions";
import L from "../Lang"
import BaseCom from "../BaseCom";
import Card from "../Card";
import FormInput from "../FormInput";
import Icon from "../Icon";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import CodeEditor from "../editors/CodeEditor";

class ReportTemplateEdit extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            item: {},
            example: {
                name: 'Example Report Template'
            }
        }
    }

    async componentDidMount() {

        if (this.props.params.id) {
            await this.loadAsync(this.props.params.id);
        }
    }

    loadAsync = async (id) => {
        try {
            let j = await qreq.getAsync('/api/report-template/' + id);
            if (j.errorCode === 0) {
                j.item._style = j.item.style;
                j.item._header = j.item.header;
                j.item._content = j.item.content;
                j.item._footer = j.item.footer;
                j.item._panelIter = j.item.panelIter;
                j.item._testIter = j.item.testIter;
                j.item._note = j.item.node;
                this.setState({ item: j.item });
            }
            else
                this.alert(j.errorMessage);
        }
        catch {
            this.unkownErrorCallback();
        }
    }

    change = () => {
        this.setState({ item: { ...this.state.item } });
    }

    submit = async (e) => {
        try {
            const item = { ...this.state.item };
            item.style = item._style;
            item.header = item._header;
            item.content = item._content;
            item.footer = item._footer;
            item.panelIter = item._panelIter;
            item.testIter = item._testIter;
            item.note = item._note;
            e?.preventDefault();
            var j = await qreq.postAsync('/api/report-template/save', item);
            if (j.errorCode === 0) {
                this.success('Report Template saved');
                this.goBack();
            }
            else
                this.alert('Error saving Report Template');
        }
        catch (e) {
            this.alert(e);
        }
    }

    changeTemplate = (c, v) => {
        this.setState({ item: { ...this.state.item, [c]: v } });
    }


    render() {
        if (!this.state.item) return;
        return <div className="container-fluid">
            <form onSubmit={this.submit}>
                <h1><L>Report Template</L></h1>
                <Card title="Basic Information">
                    <div className="row">
                        <div className="col-md-12">
                            <FormInput model={this.state.item} name="name" label="Name" required placeholder={this.state.example.name} onChange={this.change} />
                        </div>
                    </div>
                </Card>

                <Card title="Style">
                    <CodeEditor value={this.state.item.style} lang="css" height="400px" onChange={(v) => this.changeTemplate('_style', v)} />
                </Card>
                <Card title="Header">
                    <CodeEditor value={this.state.item.header} lang="html" height="400px" onChange={(v) => this.changeTemplate('_header', v)} />
                </Card>
                <Card title="Content">
                    <CodeEditor value={this.state.item.content} lang="html" height="400px" onChange={(v) => this.changeTemplate('_content', v)} />
                </Card>
                <Card title="Footer">
                    <CodeEditor value={this.state.item.footer} lang="html" height="400px" onChange={(v) => this.changeTemplate('_footer', v)} />
                </Card>
                <Card title="Panel Iteration">
                    <CodeEditor value={this.state.item.panelIter} lang="html" height="400px" onChange={(v) => this.changeTemplate('_panelIter', v)} />
                </Card>
                <Card title="Test Row Iteration">
                    <CodeEditor value={this.state.item.testIter} lang="html" height="400px" onChange={(v) => this.changeTemplate('_testIter', v)} />
                </Card>
                <Card title="Note">
                    <CodeEditor value={this.state.item.note} lang="html" height="400px" onChange={(v) => this.changeTemplate('_note', v)} />
                </Card>

                <Card title="Settings">
                    <div className="row">
                        <div className="col-md-4">
                            <FormInput model={this.state.item} name="isDisabled" label="Disable" type="switch" onChange={this.change} />
                            <small><L>Disable the Report Template completely from use.</L></small>
                        </div>
                    </div>
                </Card>
                <AppActions>
                    <button type="submit" className="btn btn-success btn-lg"><Icon icon="faSave" /> <L>Save</L></button>
                </AppActions>
            </form>
        </div>;
    }
}

export default withParamsAndNavigate(ReportTemplateEdit);